import { useState } from "react";
import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";

import ApprovalCard from "../approval-card";
import ApprovalConfirmationModal from "../approval-confirmation-modal";
import AssignModal from "../assign-modal";
import { APPROVAL_REQUIREMENT_STATUSES } from "../../helpers";
import useApprovalRequirementAction from "../../hooks/useApprovalRequirementAction";
import useApprovalRequirementAssign from "../../hooks/useApprovalRequirementAssign";

const RequirementCards = ({
    t,
    cards = [],
    softwareId,
    onGoToAssessment,
}) => {
    const [assignState, setAssignState] = useState(null);
    const [confirmState, setConfirmState] = useState(null);

    const { submit, isSubmitting } = useApprovalRequirementAction({
        softwareId,
        t,
        onSuccess: () => setConfirmState(null),
    });
    const { submit: submitAssign, isSubmitting: isAssigning } =
        useApprovalRequirementAssign({
            softwareId,
            t,
            onSuccess: () => setAssignState(null),
        });

    const handleConfirm = ({ reason } = {}) => {
        if (!confirmState?.requirementId || !confirmState?.mode) {
            return;
        }

        submit({
            requirementId: confirmState.requirementId,
            action: confirmState.mode,
            rejectionReason: reason,
        });
    };

    return (
        <>
            <Row className="g-3 required-approvals-cards">
                {cards.map((card, index) => {
                    return (
                        <Col
                            className="required-approvals-cards__col"
                            key={card.id || `${card.type}-${index}`}
                        >
                            <ApprovalCard
                                title={card.title}
                                viewModel={card}
                                isSubmitting={isSubmitting || isAssigning}
                                onAssign={() =>
                                    setAssignState({
                                        requirementId: card.id,
                                        title: card.title,
                                        assigneeId: card.assigneeId,
                                    })
                                }
                                onApprove={() =>
                                    setConfirmState({
                                        mode: "approve",
                                        requirementId: card.id,
                                        title: card.title,
                                    })
                                }
                                onReject={() =>
                                    setConfirmState({
                                        mode: "reject",
                                        requirementId: card.id,
                                        title: card.title,
                                    })
                                }
                                onChangeDecision={() =>
                                    setConfirmState({
                                        mode:
                                            card.status ===
                                            APPROVAL_REQUIREMENT_STATUSES.APPROVED
                                                ? "reject"
                                                : "approve",
                                        requirementId: card.id,
                                        title: card.title,
                                        isChangeDecision: true,
                                    })
                                }
                                onGoToAssessment={onGoToAssessment}
                            />
                        </Col>
                    );
                })}
            </Row>
            <AssignModal
                isOpen={Boolean(assignState)}
                toggle={() => setAssignState(null)}
                softwareId={softwareId}
                requirementId={assignState?.requirementId}
                title={assignState?.title}
                currentAssigneeId={assignState?.assigneeId}
                loading={isAssigning}
                onConfirm={({ userId }) =>
                    submitAssign({
                        requirementId: assignState?.requirementId,
                        userId,
                    })
                }
            />
            <ApprovalConfirmationModal
                isOpen={Boolean(confirmState)}
                toggle={() => setConfirmState(null)}
                mode={confirmState?.mode}
                roleTitle={confirmState?.title}
                isChangeDecision={confirmState?.isChangeDecision}
                loading={isSubmitting}
                onConfirm={handleConfirm}
            />
        </>
    );
};

export default withNamespaces()(RequirementCards);
